module.exports = __webpack_public_path__ + "static/gif2.b0907613.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/dtgif/gif2.gif
// module id = 540
// module chunks = 270958380025928